import { createItemStorage } from "./createItemStorage";

export const cancellationSurvey = ({ storage }) => createItemStorage(storage, "cancelSurvey");
